<template>
  <div class="left-content">
    <div class="container">
      <div class="headwrap"
           v-for="(item,index) in userData"
           :key="index">
        <user :data="item"></user>
      </div>
    </div>
    <pages :page-size="pagerParams.pageSize"
           :page-count="pagerParams.pageCount"
           :current-page.sync="pagerParams.currentPage"
           :total="pagerParams.total">
    </pages>
  </div>
</template>

<script>
  import User from '@/components/activity/User'
  import pages from '@/components/pages.vue'

  export default {
    metaInfo () {
      return {
        title: this.$t('global.报名人员') + " | MANA"
      }
  },
    components: {
      User,
      pages
    },
    data() {
      return {
        userData: [],
        pagerParams: {
          pageSize: 12,
          pageCount: 5,
          currentPage: 1,
          total: 1
        }
      }
    },
    watch: {
      'pagerParams.currentPage': function () {
        this.getData(this.$route.params.id, {pageIndex: this.pagerParams.currentPage})
      },
      $route: function () {
        let currentID = this.$route.params.id
        if (currentID == this.detailData.id) return
        this.getData(this.$route.params.id)
      }
    },
    methods: {
      getData(activityId, {pageIndex = 1, pageSize = 12} = {}) {
        this.$http
          .get('/api/activity/memberList', {
            params: {
              activityId,
              pageIndex,
              pageSize
            }
          })
          .then(data => {
            let d = data.data
            this.userData = d.list

            this.pagerParams.currentPage = d.pageIndex
            this.pagerParams.total = d.totalPage
            this.pagerParams.pageSize = d.pageSize
          })
      }
    },

    created() {
      this.getData(this.$route.params.id)
    }
  }
</script>

<style lang="stylus" scoped>
  .headwrap
    padding-top 0.8rem
    width 6.5rem
    float left

  .headwrap:nth-child(2n)
    width 3.9rem

  .left-content
    display flex
    /* justify-content space-between */
    flex-wrap wrap
    width 10.8rem
    margin-top 0.2rem
    padding 0 0.6rem
    background-color #ffffff
    .container
      width 100%
</style>



// WEBPACK FOOTER //
// src/pages/activity/match/Participants.vue